import ReplaceParticipant from './ReplaceParticipantContainer';
export default ReplaceParticipant;
